export default [
    {
        path: 'create/:type?',
        name: 'partner-create',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.partners', 1)}).ucFirst()
        },
        component: () => import('@/views/pages/partners/partners/item.vue')
    },
    {
        path: ':id(\\d+)',
        name: 'partner-edit',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.partners', 1)}).ucFirst()
        },
        component: () => import('@/views/pages/partners/partners/item.vue'),
        redirect: { name: 'partner-base-information'},
        children: [
            {
                path: ':type?',
                name: 'partner-edit-type',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('menu_points.partners', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/partners/item.vue'),
            },
            {
                path: 'projects/:type?',
                name: 'partner-projects',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partner_projects').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/projects/partner.vue')
            },
            {
                path: 'base-information/:type?',
                name: 'partner-base-information',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partner_base_informations').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/partners/edit.vue')
            },
            {
                path: 'contacts/:type?',
                name: 'partner-contacts',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partner_contacts').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/contacts/manage.vue')
            },
            {
                path: 'decision-makers/:type?',
                name: 'partner-decision-makers',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partner_decision_makers').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/decision-makers/manage.vue')
            },
            {
                path: 'addresses/:type?',
                name: 'partner-addresses',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.partner_addresses').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/addresses/manage.vue')
            },
        ]
    },
    {
        path: 'my-partners',
        name: 'my-partners',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_partners').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'my-partners-list' },
        children: [
            {
                path: '',
                name: 'my-partners-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_partners').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/partners/my.vue'),
            },
            {
                path: 'create/:type?',
                name: 'my-partner-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.my_partners', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/partners/item.vue')
            },
        ]
    },
    {
        path: 'accessible-partners',
        name: 'accessible-partners',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.accessible_partners').ucFirst();
            },
        },
        component: () => import('@/views/pages/partners/partners/accessible.vue'),
        redirect: { name: 'accessible-partners-list' },
        children: [
            {
                path: '',
                name: 'accessible-partners-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.accessible_partners').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/partners/accessible.vue'),
            },
            {
                path: 'create/:type?',
                name: 'accessible-partner-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('menu_points.accessible_partners', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/partners/item.vue')
            },
        ]
    },
    {
        path: 'all',
        name: 'all-partner',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.all_partner').ucFirst();
            },
        },
        component: () => import('@/views/pages/partners/partners/all.vue')
    },
    {
        path: 'free',
        name: 'free-partner',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.free_partner').ucFirst();
            },
        },
        component: () => import('@/views/pages/partners/partners/free.vue')
    },
    {
        path: 'merge',
        name: 'merge-partner',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.merge_partner').ucFirst();
            },
        },
        component: () => import('@/views/pages/partners/partners/merge.vue')
    },
    {
        path: 'campaign',
        name: 'launch-campaign',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.campaign').ucFirst();
            },
        },
        component: () => import('@/views/pages/partners/partners/campaign.vue')
    }
]